import { AddressMap } from 'src/types'
import { ChainId } from '../enums/ChainId'

export const INIT_CODE_HASH: { [chainId: number]: string } = {
  [ChainId.AVALANCHE]: '0x9e43ee37212e3296c7f6087d3e0a37b48a4e4e413538dac0fd18cfe2f80666c1',
  [ChainId.BSC]: '0x2ed0c8714ca80192f88764ee4b4c8c8cb6dfc01859a02b25ce67f304e499d48e',
  [ChainId.MATIC]: '0x2ed0c8714ca80192f88764ee4b4c8c8cb6dfc01859a02b25ce67f304e499d48e',
  [ChainId.FANTOM]: '0xcb64282d14f9033fbb6a3a827bd515fff027bb6994a0d33ac0424e7e3037dad3',
  [ChainId.ETHEREUM]: '0x2ed0c8714ca80192f88764ee4b4c8c8cb6dfc01859a02b25ce67f304e499d48e',
  [ChainId.OPTIMISM]: '0x2ed0c8714ca80192f88764ee4b4c8c8cb6dfc01859a02b25ce67f304e499d48e',
  [ChainId.ARBITRUM]: '0x2ed0c8714ca80192f88764ee4b4c8c8cb6dfc01859a02b25ce67f304e499d48e',
  [ChainId.TELOS]: '0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd',
  [ChainId.TELOS_TESTNET]: '0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd',
  [ChainId.MANTLE_TESTNET]: '0x5e1d196be4a859f73a656ec6b02da4a9530c56505a7638308b6d04661f45f38f',
  [ChainId.MANTLE]: '0x5e1d196be4a859f73a656ec6b02da4a9530c56505a7638308b6d04661f45f38f',
}

export const INIT_CODE_HASH_PORTFOLIO: { [chainId: number]: string } = {
  [ChainId.AVALANCHE]: '0x9e43ee37212e3296c7f6087d3e0a37b48a4e4e413538dac0fd18cfe2f80666c1',
  [ChainId.BSC]: '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5',
  [ChainId.MATIC]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  [ChainId.FANTOM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  [ChainId.ETHEREUM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  [ChainId.OPTIMISM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  [ChainId.ARBITRUM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  [ChainId.TELOS]: '0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd',
  [ChainId.TELOS_TESTNET]: '0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd',
  [ChainId.MANTLE_TESTNET]: '0x5e1d196be4a859f73a656ec6b02da4a9530c56505a7638308b6d04661f45f38f',
  [ChainId.MANTLE]: '0x5e1d196be4a859f73a656ec6b02da4a9530c56505a7638308b6d04661f45f38f',
}

export const FACTORY_ADDRESS: AddressMap = {
  [ChainId.ETHEREUM]: "0x2F0C7C98462651BB2102F6Cd05acDAd333E031b0",
  [ChainId.OPTIMISM]: "0x2F0C7C98462651BB2102F6Cd05acDAd333E031b0",
  [ChainId.ARBITRUM]: "0x2F0C7C98462651BB2102F6Cd05acDAd333E031b0",
  [ChainId.MATIC]: "0x735ab9808d792B5c8B54e31196c011c26C08b4ce",
  [ChainId.FANTOM]: "0x98F23162E3a7FE610aC89C88E4217a599A15858F",
  [ChainId.BSC]: "0xEe673452BD981966d4799c865a96e0b92A8d0E45",
  [ChainId.AVALANCHE]: "0x9c60c867ce07a3c403e2598388673c10259ec768",
  [ChainId.TELOS]: "0xb630f53df13645bff0ef55eb44a8a490a7dd4514",
  [ChainId.TELOS_TESTNET]: "0x722F473AE392eF537D74f8F71602A584a10739F0",
}